export const EMAIL_REGEXP = /^(( *[^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,}) *$/i;
export const EMAIL_MAX_LENGTH = 320;